import styled from 'styled-components'

export const BottomBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 50px;

  > div:nth-child(2) {
    button {
      margin-left: 30px;
    }
  }
`

export default BottomBlock
